namespace GeniuzPOS.PriceChange {
    export interface PostFgListRequest extends Serenity.ListRequest {
        PostFg?: number[];
    }
}
